<template>
    <div class='foot'>
        <div class='imgBox'>
            <ul class='oUl'>
                <li v-for='(item,index) in imgList' :key='index' class="oli">
                    <a :href="item.aUrl" target="_blank" style="display: inline-block"><img :src="item.imgUrl" alt="" srcset=""></a>
                </li>
            </ul>
            <ul class='oUl'>
                <li v-for='(item,index) in imgListTwo' :key='index' class="oli">
                    <a :href="item.aUrl" target="_blank" style="display: inline-block"><img :src="item.imgUrl" alt="" srcset=""></a>
                </li>
            </ul>
        </div>
        <div class="content">
            <p>
                Corpyright © 中卫佰医科技有限公司版权所有 <a class="link" href="https://beian.miit.gov.cn/" target="_blank">京ICP备17062576号-2</a>
            </p>
            <p>
                服务声明：专家咨询建议仅供参考_不能作为诊断及医疗的依据
            </p>
            <p>
                 <img src="./../../assets/Mobile/foot/Bitmap.png" alt="">   京公网安备 11010802017313号
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                imgList: [
                    {
                        aUrl: 'http://www.cyberpolice.cn/wfjb/',
                        imgUrl: require('./../../assets/Mobile/foot/icon-01.png')
                    },
                    {
                        aUrl: '',
                        imgUrl: require('./../../assets/Mobile/foot/icon-02.png')
                    },
                    {
                        aUrl: '',
                        imgUrl: require('./../../assets/Mobile/foot/icon-03.png')
                    }
                ],
                imgListTwo: [
                    {
                        aUrl: '',
                        imgUrl: require('./../../assets/Mobile/foot/icon-04.png')
                    },
                    {
                        aUrl: '',
                        imgUrl: require('./../../assets/Mobile/foot/icon-05.png')
                    },
                    {
                        aUrl: '',
                        imgUrl: require('./../../assets/Mobile/foot/icon-06.png')
                    }
                ]
            }
        },
    }
</script>
<style lang="less" scoped>
.foot{
    height:300px;
background:linear-gradient(89deg,rgba(30,97,227,1),rgba(68,87,192,1));
}
.oUl{
    display:flex; 
    flex:1;
    justify-content: center;

    &:nth-child(2){
        .oli{
            margin-top: 0;
            margin-bottom:0;
        }
    }
}
.oli{
    width: 145px; height: 50px;  margin: 30px;
    img{
        display:block;
        width:100%;
        height: 100%;
    }
}
.content{
    text-align: center; 
    font-size: 24px;
    color: #fff;
    font-family: PingFangSC-Light;
    line-height: 44px;
    text-align: center;
    transform: scale(0.7);

    .link {
        color: #fff;
    }
}
</style>